import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppLayout({ children, searchPlaceholder }) {
    return (
        <div className="min-h-screen bg-ink-900 flex text-white">
            <Sidebar />
            <div className="flex-1 min-w-0 flex flex-col">
                <Topbar searchPlaceholder={searchPlaceholder} />
                <main className="flex-1 p-6 lg:p-10">{children}</main>
            </div>
        </div>
    );
}
